export default {
  title: "Sub-exhibitors",
  totalArea: "Area: {area} m<sup>2</sup>",

  withDeligatedAccess: "Delegated",
  withReadAccess: "Read only",
  read: "Read only",
  edit: "Editing",
  addSubexponentBtn: "Add sub-exhibitor",
  manageSubexponentsBtn: "Manage sub-exhibitors",
  lookSubexponentsBtn: "Look sub-exhibitors",

  pluralize: ["sub-exhibitor", "sub-exhibitors"],
  notConfirmed: "Not confirmed",

  modal: {
    totalExhibitors: "Total: {amount}",
    tooltip: "Number of free Exhibitor passes.",
    totalQuotas: "Total quotas:",
    availableQuotas1: "Available",
    availableQuotas2: ":",
    availableQuotasAll: "Available quotas:",
    availablePasses: "Available quotas",
    oldYearsSubexponentTitle: "Co-exhibitors of previous exhibitions",
    addSubexponentTitle: "Add sub-exhibitor",
    addSubexponentTitle2: "Create new sub-exhibitor", // Создать нового субэкспонента
    addQuotasLabel: "Quota",
    addMoreSubexponent: "Add one more",
    newSubexponents: "New co-exhibitors",

    inn: "Registration №",

    validateEmail: "Field must be valid e-mail",
    duplicationEmail: "This e-mail is already in use",

    SelectedSubexponents: "Selected sub-exhibitor",

    addHint:
      "An e-mail will be sent to the indicated e-mail address allowing you to activate all the features of your personal account.",

    deleteAll: "Delete all",

    searchPlaceholder: "Search for a sub-exhibitor",

    viewByList: "List View",
    viewByCards: "Cards View",

    deleteAlert:
      "Are you sure you want to delete the sub-exhibitor? All passes created by him will also be deleted.",
    deleteAllAlert: "Are you sure you want to delete all sub-exhibitors?",

    accountNotActivated: "Account isn't activated",
    colOrgControlsSubexp: "You're managing sub-exhibitor",
    colOrgDeletegatedSubexp: "You've delegated control to sub-exhibitor",
    resendBtn: "Resend access code",

    companyProfile: "Company profile",
    companyProfileFilled: "Completed",
    companyProfileNotFilled: "Partly filled in",
    catalogApplication: "Publication in the Catalogue",
    catalogApplicationSent: "Sent",
    catalogApplicationNotSent: "Not sent",
    participantPasses: "Exhibitor passes",
    carPasses: "One-entry car passes",

    access: "Access",

    recentlyAdded: "Recently added",
    selectAll: "All"
  }
};
